export const LIST = [
  { image: 'magnet', title: 'Больше клиентов', description: ['~150 000 платных аккаунтов'] },
  { image: 'megaphone', title: 'Больше объявлений', description: ['~2,1 млн активных объявлений'] },
  {
    image: 'avatar',
    title: 'Больше пользавателей',
    description: ['>19,5 млн уникальных посетителей ежемесячно (UMV)'],
  },
  {
    image: 'people',
    title: 'Больше клиентов',
    description: ['>3 млн целевых действий', '>250 000 лидов для застройщиков'],
  },
];

export const DESCRIPTION = [
  {
    value:
      'Рост числа клиентов Циан — собственников, профессионалов рынка недвижимости, застройщиков и покупателей — увеличивает объем объявлений и интерес пользователей. Это делает платформу более ценной для каждого участника рынка.',
  },
];
